import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { CookieService } from 'ngx-cookie-service';
import { DataencryptionService } from './dataencryption.service';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { SendSMS } from '../user-view/models/sendSMS';

@Injectable()
export class ChartService {
  localBodyName:string;
  localBodyId:number;
  headers: Headers;
  options: RequestOptions;
  decryptUID: any;
  decryptToken: any;
  UID: any;
  Token: any;
  storageArr: any[];
  storageArr1: any[];
  testDistrict:any[];
  storageEl: any;
  storageEl1: any;
  storageEl2: any;
  storageElEpid: any;
  registerCandidateDtl : any[];
  talukaId:number;

  BaseUrl = "https://webapi.truevoter.in/api";
  // BaseUrl = environment.config.baseUrlDotNet;
   //baseUrl="https://webapi.truevoter.in/api"

  //  BaseUrl1="https://webapi.truevoter.in/api"
  // BaseUrl = environment.config.baseUrlDhananjoy;
  BaseUrl3 = environment.config.baseUrlNomDhananjoy;
  BaseUrl2 = environment.config.baseUrlDhananjoy1;
  // BaseUrl2="https://webapi.truevoter.in/api"

  BaseUrlSujit = environment.config.baseUrlSujit;
  constructor(private _http: Http, private cookieService: CookieService,
    private _encData: DataencryptionService) {
    this.headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json' });
    this.options = new RequestOptions({ headers: this.headers });

    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    this.UID = this.decryptUID.toString(CryptoJS.enc.Utf8);

    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    this.Token = this.decryptToken.toString(CryptoJS.enc.Utf8);
  }

  downloadTotalExpenseByWard(epId, lbId, uId) {
    // tslint:disable-next-line:max-line-length
    return this._http.get(this.BaseUrl + '/DailyExpense/totalExpense?epId=' + epId
      + '&localBodyId=' + lbId + '&uId=' + uId)
      .map(res => res.json());
  }


  downloadTotalExpenseByWardDistrict(epId, distId, uId) {
    // tslint:disable-next-line:max-line-length
    return this._http.get(this.BaseUrl + '/DailyExpense/totalExpenseDistrict?epId=' + epId
      + '&distId=' + distId + '&uId=' + uId)
      .map(res => res.json());
  }

  downloadLocalBodyPrintData(epId, lbId, uId) {
    // tslint:disable-next-line:max-line-length
    return this._http.get(this.BaseUrl + '/DashBoard/downloadPrintednNotLB1?epId=' + epId + '&localBodyId=' + lbId + '&uId=' + uId)
      .map(res => res.json());
    // return this._http.get('http://192.168.0.103:8080/True_Voter/downloadPrintednNotLB?epId=30&localBodyId=54321')
    //     .map(res => res.json());
  }


  downloadLocalBodyPrintDataDistrict(epId, distId, uId) {
    // tslint:disable-next-line:max-line-length
    return this._http.get(this.BaseUrl + '/Dashboard/downloadPrintednNotLBDistrict?epId=' + epId + '&distId=' + distId + '&uId=' + uId)
      .map(res => res.json());
    // return this._http.get('http://192.168.0.103:8080/True_Voter/downloadPrintednNotLB?epId=30&localBodyId=54321')
    //     .map(res => res.json());
  }


  downloadWardNoPrintData(date: string, epId: any, lbId: any) {
    // https://webapi.truevoter.in/api/Dashboard/downloadPrintednNotGrp?epId=31&localBodyId=98765&date=2018-07-14
    return this._http.get(this.BaseUrl + '/Dashboard/downloadPrintednNotGrp?epId='
      + epId + '&localBodyId='
      + lbId + '&date=' + date)
      .map(res => res.json());
  }

  downloadDashboardForNomFill() {
    // problem in sp dotnet
    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    this.UID = this.decryptUID.toString(CryptoJS.enc.Utf8);

    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    this.Token = this.decryptToken.toString(CryptoJS.enc.Utf8);
    return this._http.get(this.BaseUrl + '/DashBoard/dateWiseNomination?date=2018-05-10&uId='
      + this.UID + '&token=' + this.Token + '&epId=65')
      .map(res => res.json());
    // return this._http.get(this.BaseUrl1 + '/dateWiseNomination?date=2018-05-10&uId='
    //    + this.UID + '&token=' + this.Token + '&epId=65') 
    //    .map(res => res.json());
  }

  downloadDashboardForSub() {
    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    this.UID = this.decryptUID.toString(CryptoJS.enc.Utf8);

    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    this.Token = this.decryptToken.toString(CryptoJS.enc.Utf8);
    return this._http.get(this.BaseUrl + '/DashBoard/DateWiseSubmissionCount?date=2018-05-10&uId='
      + this.UID + '&token=' + this.Token + '&epId=65')
      .map(res => res.json());
  }

  downloadDashboardForScrutiny() {
    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    this.UID = this.decryptUID.toString(CryptoJS.enc.Utf8);

    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    this.Token = this.decryptToken.toString(CryptoJS.enc.Utf8);
    return this._http.get(this.BaseUrl + '/DashBoard/DateWiseScrutinyCount?date=2018-05-10&uId='
      + this.UID + '&token=' + this.Token + '&epId=65')
      .map(res => res.json());
  }

  downloadNomSubmissionCount() {
    return this._http.get(this.BaseUrl + '/DashBoard/nominationSubmissionStatus?epId='
      + localStorage.getItem('electionProgId'))
      .map(res => res.json());
  }

  downloadNomScrutinyCount() {
    return this._http.get(this.BaseUrl + '/DashBoard/fetchSuStatus?electionProgram='
      + localStorage.getItem('electionProgId'))
      .map(res => res.json());
  }

  downloadNomSymbolAllotCount() {
    return this._http.get(this.BaseUrl + '/DashBoard/symbolallotmentStatus?epId='
      + localStorage.getItem('electionProgId'))
      .map(res => res.json());
  }

  downloadMulCount(epId, lbId, distId, uId) {

    // https://webapi.truevoter.in/api/DashBoard/RoDashboardCnt?epId=356&localBodyId=5455&distId=521&uId=c5905e63-afa6-4c44-9b2a-a6959d52cf9d
      
    return this._http.get(this.BaseUrl + '/DashBoard/RoDashboardCnt?epId='
      + epId + '&localBodyId=' + lbId + '&distId=' + distId + '&uId=' + uId)
      .map(res => res.json());
  }
//-----------sushmita-05-08-2024-------------//

downloadMulCountnew(epId, lbId, distId, uId,officerMobNo) {
  // https://webapi.truevoter.in/api/DashBoard/RoDashboardCnt?epId=356&localBodyId=5455&distId=521&uId=c5905e63-afa6-4c44-9b2a-a6959d52cf9d
  return this._http.get(this.BaseUrl + '/DashBoard/RoDashboardCnt_ExpenseFilledbyOfficer?epId='
    + epId + '&localBodyId=' + lbId + '&distId=' + distId + '&uId=' + uId+'&officerMobNo='+officerMobNo)
    .map(res => res.json());
}

  downloadMulCountDistrict(epId,distId, uId) {
    return this._http.get(this.BaseUrl + '/Dashboard/downloadRoDashBoardDistrict?EpId='
      + epId +  '&distId=' + distId + '&uId=' + uId)
      .map(res => res.json());
  }


  // + localStorage.getItem('')
  downloadWardWiseTotReport(epId, wardNo, lbId, distId) {
    return this._http.get(this.BaseUrl + '/DashBoard/wardWiseTotalDevRepo1?epId='
      + epId + '&localBodyId=' + lbId
      + '&wardNo=' + wardNo + '&distId=' + distId)
      .map(res => res.json());
  }

  // pieChart data for deviation report

  downloadDeviationReportForWard(epId, wardNo, lbId, distId) {
    return this._http.get(this.BaseUrl + '/DashBoard/wardExpReview1?epId='
      + epId + '&localBodyId=' + lbId
      + '&wardNo=' + wardNo + '&distId=' + distId)
      .map(res => res.json());
  }

  // wardWise deviation count and report in grid

  downloadParticularDeviationReport(wardNo, type) {
    return this._http.get(this.BaseUrl + '/DashBoard/downloadDeviReview?epId='
      + localStorage.getItem('electionProgId') + '&localBodyId=' + localStorage.getItem('localBodyId')
      + '&wardNo=' + wardNo + '&type=' + type)
      .map(res => res.json());
  }

  // download emc count report

  downloadEmcCountReport(epId, wardNo, lbId, distId, lbtype) {
    return this._http.get(this.BaseUrl + '/DashBoard/downloadEMCRemarkCount1?epId='
      + epId + '&localBodyId=' + lbId
      + '&wardNo=' + wardNo + '&districtId=' + distId + '&localBodyType=' + lbtype)
      .map(res => res.json());
  }

  // download voter objection report
  //https://webapi.truevoter.in/api/DashBoard/downloadVoterObjCount1?epId=30&wardNo=4&localBodyId=54321&distId=530
  downloadVoterObjReport(epId, wardNo, lbId, distId) {
    return this._http.get(this.BaseUrl + '/DashBoard/downloadVoterObjCount1?epId='
      + epId + '&wardNo=' + wardNo + '&localBodyId=' + lbId
      + '&distId=' + distId)
      .map(res => res.json());
  }downloadExpensePrintReport

  // most deviated data list

  downloadMostDeviatedList(epId, wardNo, lbId, distId) {
    return this._http.get(this.BaseUrl + '/DashBoard/mostDaviatedList1?epId='
      + epId + '&localBodyId=' + lbId
      + '&wardNo=' + wardNo + '&distId=' + distId)
      .map(res => res.json());
  }

  // download List of person who have printed daily expense
  downloadExpensePrintedPersonList(wardNo: number, date: string, lbId: any, epId: any) {
    // https://webapi.truevoter.in/api/DashBoard/recordsOfPrinted?epId=337&localBodyId=13391&wardNo=17&date=2021-12-13
    return this._http.get(this.BaseUrl + '/DashBoard/recordsOfPrinted?epId='
      + epId + '&localBodyId=' +
      lbId + '&wardNo=' + wardNo + '&date=' + date)
      .map(res => res.json());

  }

  // download List of person who have not printed daily expense
  downloadExpenseNotPrintedPersonList(date: string, wardNo: number, epId, lbId) {
    // https://webapi.truevoter.in/api/DashBoard/recordsOfNotPrinted?epId=353&localBodyId=37264&wardNo=1&date=2018-05-09
    return this._http.get(this.BaseUrl + '/DashBoard/recordsOfNotPrinted?epId='
      + epId + '&localBodyId=' +
      lbId + '&wardNo=' + wardNo + '&date=' + date)
      .map(res => res.json());
  }

  // download List of person who have printed past daily expense
  downloadExpensePreDatedPersonList(date: string, lbId: any, wardNo: number) {
    // not found dotnet
    return this._http.get(this.BaseUrl + '/predatedprintlog?printDate=' + date + '&localBodyId=' + lbId + '&wardNo=' + wardNo)
      .map(res => res.json());
  }
  // emc report ward wise

  downloadEMCReportWardWiseOnPieClick(wardNo, type) {
    return this._http.get(this.BaseUrl + '/DashBoard/downloadEMCRemarkReview?epId='
      + localStorage.getItem('electionProgId') + '&localBodyId=' + localStorage.getItem('localBodyId')
      + '&wardNo=' + wardNo + '&type=' + type)
      .map(res => res.json());
  }

  // download nomination count data

  downloadNominationFilledCountReport(epId, wardNo, lbId, distId, uId) {
    return this._http.get(this.BaseUrl + '/Dashboard/nominationFilledCnt?distId='
      + distId + '&epId=' + epId
      + '&localBodyId=' + lbId + '&wardNo=' + wardNo + '&uId=' + uId)
      .map(res => res.json());
  }

  //  download registered and not registered candidate

  downloadRegisteredAndNotRegisteredCandidate(epId, wardNo, lbId, distId, uId) {
    return this._http.get(this.BaseUrl + '/Dashboard/registerednNotCnt?distId='
      + distId + '&epId=' + epId
      + '&localBodyId=' + lbId + '&wardNo=' + wardNo + '&uId=' + uId)
      .map(res => res.json());
  }

  downloadRegisteredAndNotRegisteredCandidateDistrict(epId, distId, uId) {
    return this._http.get(this.BaseUrl + '/Dashboard/registerednNotCntDistrict?epId='
      + epId + '&distId=' +  distId + '&uId=' + uId)
      .map(res => res.json());
  }

  // download expense not filled count

  downloadExpenseNotFilledCount(epId, wardNo, lbId, distId, uId) {
    return this._http.get(this.BaseUrl + '/Dashboard/notInExpenseCnt?distId='
      + distId + '&epId=' + epId
      + '&localBodyId=' + lbId + '&wardNo=' + wardNo + '&uId=' + uId)
      .map(res => res.json());
  }


  downloadExpenseNotFilledCountDistrict(epId,distId, uId) {
    return this._http.get(this.BaseUrl + '/Dashboard/notInExpenseCntDistrict?epId='
      + epId + '&distId=' + distId
       + '&uId=' + uId)
      .map(res => res.json());
  }


  // download register not registered app record

  downloadRegisteredNotRegisterdGridReport(type, wardNo, epId, lbId, distId) {
    return this._http.get(this.BaseUrl + '/Dashboard/downloadRegnNot?distId='
      + distId + '&epId=' + epId
      + '&localBodyId=' + lbId + '&wardNo=' + wardNo + '&type=' + type)
      .map(res => res.json());
  }

  downloadLocalBodyData(distId) {
    return this._http.get(this.BaseUrl + '/DashBoard/downloadLBByDist?districtId=' + distId)
      .map(res => res.json());
  }

  
  downloadLBByDistAndEpid(epId : any ,districtId : any ){
    return this._http.get(this.BaseUrl + '/DashBoard/downloadLBByDist?districtId=' + districtId )
    .map(res => res.json());
  }

  // download district id based on district short name

  downloadDistirctIdForMap(shortName) {
    return this._http.get(this.BaseUrl + '/Dashboard/downloadDistIdByShortName1?shortName=' + shortName)
      .map(res => res.json());
  }

  downloadDistrictForMap(epId) {
    return this._http.get(this.BaseUrl + '/Dashboard/downloadDistLBByEP?epId=' + epId)
      .map(res => res.json());
  }

  sendSMS(sms: SendSMS[]) {
    return this._http.post(this.BaseUrl + '/Registration/sendMsgtoNotReg', sms)
      .map(res => res.json());
  }

  getNotPrintedData(wardNo, epId, lbId, distId) {
    
    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    this.UID = this.decryptUID.toString(CryptoJS.enc.Utf8);

    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    this.Token = this.decryptToken.toString(CryptoJS.enc.Utf8);
    return this._http.get(this.BaseUrl + '/Dashboard/notfilledExpensesBycandidate?epId=' + epId + '&distId=' + distId +
      '&localBodyId=' + lbId + '&wardNo=' + wardNo + '&uId=' + this.UID + '&token=' + this.Token)
      .map(res => res.json());
  }


  downloadStandardRateReport(lbId, epId, distId) {
    return this._http.get(this.BaseUrl + '/StandardRateUpload/downloadMultipleExpense?localBodyId=' + lbId +
      '&electionProgramId=' + epId + '&districtId=' + distId)
      .map(res => res.json());

  }

  sendExpenseReportOfCandidate(epId: number) {
    return this._http.get(this.BaseUrl + '/sendExpenseCountOfCandidate?epId=' + epId)
      .map(res => res.json());
  }

}




// WEBPACK FOOTER //
// ./src/app/shared/chart.service.ts